﻿<template>

    <div class="lg-head">
        <span class="lg-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.78 7.78 5.5 5.5 0 0 1 7.78-7.78zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" /></svg>
        </span>
        <h2 class="lg-heading">Reset password</h2>
        <p class="lg-intro">Enter your agency email address and we'll email you a link to reset your password.</p>
    </div>

    <login_alert :message="message" :type="message_type" :title="message_type == 'success' ? 'Check your email' : ''" @dismiss="message = ''"></login_alert>

    <div v-if="!reset_sent" class="lg-form">
        <div class="mb-field">
            <label for="reset_email">Email address</label>
            <div class="lg-input-wrap">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="2" y="4" width="20" height="16" rx="2" /><path d="M22 7l-10 6L2 7" /></svg>
                <input class="mb-input lg-input" type="text" name="email" id="reset_email" autocomplete="username" spellcheck="false" placeholder="Email address" v-model="Request_Password_Reset.user_name" />
            </div>
        </div>

        <button type="button" class="button button-pink-book full lg-submit" :disabled="resetting" @click="Reset_Password()">
            <svg v-if="resetting" class="mb-spinner" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" /><path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" /></svg>
            {{ resetting ? 'Sending…' : 'Reset password' }}
        </button>
    </div>
    <button v-else type="button" class="button button-pink-book full lg-submit" @click="Login()">Back to login</button>

    <div class="lg-links">
        <button type="button" class="lg-link" @click="Login()">Back to login</button>
        <button v-if="!hide_new_agent_link()" type="button" class="lg-link" @click="Register()">New agent? Register here</button>
    </div>

    <p class="lg-contact">{{getContactInfo()}}</p>

</template>

<script lang="ts" src="./forgot_password_screen.ts"></script>
